import type { Workspace } from '@/entities/workspace/types';
import type { TrackEvent } from '@/shared/track/events';
import type { UtmParams } from '@/shared/track/utm';
import type { User } from '../../entities/user/types';

const canTrackWithGtm = () => typeof window !== 'undefined' && Array.isArray(window.dataLayer);

export const identifyGTM = (user: User, workspace: Workspace) => {
  if (!canTrackWithGtm()) return;
  window.dataLayer.push({
    event: 'user_context',
    email: user.email,
    role: workspace.privilege,
    workspace_id: workspace.id,
    workspace_name: workspace.name,
  });
};

export const trackLoginSuccess = (
  email: string,
  vendorType: 'google' | 'microsoft',
  utm?: UtmParams,
) => {
  if (!canTrackWithGtm()) return;
  if (!utm) return;

  window.dataLayer.push({
    event: 'login',
    email: email,
    vendor_type: vendorType,
    ...utm,
  });
};

export const trackGtmEvent = (event: TrackEvent) => {
  if (!canTrackWithGtm()) return;
  window.dataLayer.push({
    event: event.name,
    ...event.properties,
  });
};
